"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.splitPartialIdAndOperator = exports.isCwvMetric = exports.getCwvMetrics = exports.CwvPartialMetricId = void 0;
const global_constants_1 = require("@contentsquare/global-constants");
const global_1 = require("../global");
const utils_1 = require("../utils");
var CwvPartialMetricId;
(function (CwvPartialMetricId) {
    CwvPartialMetricId["LargestContentfulPaint"] = "largestContentfulPaint";
    CwvPartialMetricId["CumulativeLayoutShift"] = "cumulativeLayoutShift";
    CwvPartialMetricId["FirstInputDelay"] = "firstInputDelay";
    CwvPartialMetricId["FirstContentfulPaint"] = "firstContentfulPaint";
    CwvPartialMetricId["TimeToFirstByte"] = "timeToFirstByte";
})(CwvPartialMetricId = exports.CwvPartialMetricId || (exports.CwvPartialMetricId = {}));
function getCwvMetrics(operator = utils_1.MetricOperator.Average) {
    return [
        {
            id: `${CwvPartialMetricId.LargestContentfulPaint}${operator}`,
            interface: [global_constants_1.Interface.Site, global_constants_1.Interface.Page],
            devices: [global_constants_1.Device.All, global_constants_1.Device.Desktop, global_constants_1.Device.Mobile, global_constants_1.Device.Tablet],
            isEcommerce: false,
            name: 'METRIC.LARGEST_CONTENTFUL_PAINT',
            definition: 'METRIC.DEFINITION.LARGEST_CONTENTFUL_PAINT',
            category: global_1.MetricCategory.Speed,
            formatType: utils_1.NumberFormatTypes.Seconds,
            format: (value, options) => utils_1.Formatter.seconds(value, options),
        },
        {
            id: `${CwvPartialMetricId.CumulativeLayoutShift}${operator}`,
            interface: [global_constants_1.Interface.Site, global_constants_1.Interface.Page],
            devices: [global_constants_1.Device.All, global_constants_1.Device.Desktop, global_constants_1.Device.Mobile, global_constants_1.Device.Tablet],
            isEcommerce: false,
            name: 'METRIC.CUMULATIVE_LAYOUT_SHIFT',
            definition: 'METRIC.DEFINITION.CUMULATIVE_LAYOUT_SHIFT',
            category: global_1.MetricCategory.Speed,
            formatType: utils_1.NumberFormatTypes.Number,
            format: (value, options) => utils_1.Formatter.number(value, options),
        },
        {
            id: `${CwvPartialMetricId.FirstInputDelay}${operator}`,
            interface: [global_constants_1.Interface.Site, global_constants_1.Interface.Page],
            devices: [global_constants_1.Device.All, global_constants_1.Device.Desktop, global_constants_1.Device.Mobile, global_constants_1.Device.Tablet],
            isEcommerce: false,
            name: 'METRIC.FIRST_INPUT_DELAY',
            definition: 'METRIC.DEFINITION.FIRST_INPUT_DELAY',
            category: global_1.MetricCategory.Speed,
            formatType: utils_1.NumberFormatTypes.Milliseconds,
            format: (value, options) => utils_1.Formatter.milliseconds(value, options),
        },
        {
            id: `${CwvPartialMetricId.FirstContentfulPaint}${operator}`,
            interface: [global_constants_1.Interface.Site, global_constants_1.Interface.Page],
            devices: [global_constants_1.Device.All, global_constants_1.Device.Desktop, global_constants_1.Device.Mobile, global_constants_1.Device.Tablet],
            isEcommerce: false,
            name: 'METRIC.FIRST_CONTENTFUL_PAINT',
            definition: 'METRIC.DEFINITION.FIRST_CONTENTFUL_PAINT',
            category: global_1.MetricCategory.Speed,
            formatType: utils_1.NumberFormatTypes.Seconds,
            format: (value, options) => utils_1.Formatter.seconds(value, options),
        },
        {
            id: `${CwvPartialMetricId.TimeToFirstByte}${operator}`,
            interface: [global_constants_1.Interface.Site, global_constants_1.Interface.Page],
            devices: [global_constants_1.Device.All, global_constants_1.Device.Desktop, global_constants_1.Device.Mobile, global_constants_1.Device.Tablet],
            isEcommerce: false,
            name: 'METRIC.TIME_TO_FIRST_BYTE',
            definition: 'METRIC.DEFINITION.TIME_TO_FIRST_BYTE',
            category: global_1.MetricCategory.Speed,
            formatType: utils_1.NumberFormatTypes.Milliseconds,
            format: (value, options) => utils_1.Formatter.milliseconds(value, options),
        },
    ];
}
exports.getCwvMetrics = getCwvMetrics;
const metricsValues = Object.values(CwvPartialMetricId);
const operatorValues = Object.values(utils_1.MetricOperator);
const cwvMetricRegexp = new RegExp(`(?<partialId>${metricsValues.join('|')})(?<operator>${operatorValues.join('|')})`);
function isCwvMetric(metricId) {
    return cwvMetricRegexp.test(metricId);
}
exports.isCwvMetric = isCwvMetric;
function splitPartialIdAndOperator(metricId) {
    var _a, _b;
    const matches = metricId.match(cwvMetricRegexp);
    if (!matches || !((_a = matches.groups) === null || _a === void 0 ? void 0 : _a.partialId) || !((_b = matches.groups) === null || _b === void 0 ? void 0 : _b.operator)) {
        throw new Error('Error while splitting partialId and operator');
    }
    return {
        partialId: matches.groups.partialId,
        operator: matches.groups.operator,
    };
}
exports.splitPartialIdAndOperator = splitPartialIdAndOperator;
//# sourceMappingURL=cwv-metric.js.map